/* =============================================================
 * import
 * ========================================================== */
import Swiper from 'swiper/bundle';


/* =============================================================
 * function
 * ========================================================== */
export default function exe() {
  clubSwiper();
}

export function clubSwiper() {
  const swiperContainer = document.querySelector('.swiper');

  if (swiperContainer) {
    const slides = swiperContainer.querySelectorAll('.swiper-slide');
    let opt;
    if (slides.length >= 2) {
      // 2枚以上の場合
      opt = {
        slidesPerView: 'auto', // コンテナ内に表示させるスライド数（CSSでサイズ指定する場合は 'auto'）
        speed: 800, // スライドアニメーションのスピード（ミリ秒）

        // cssMode: true,              // true: CSS Scroll Snap APIが適用
        mousewheel: true,           // true: マウスホイールでの操作を許可
        // keyboard: true,             // true: キーボードでの操作を許可
        grabCursor: true,              // PCでマウスカーソルを「掴む」マークにする
        watchSlidesProgress: true,     // スライドの進行状況を監視する

        /*
        freeMode: {
          enabled: true, // true：自由にドラッグ（スワイプ）できるようにする。スライド位置がスナップしなくなる
          momentum: true, // false：ドラッグ（スワイプ）した後の慣性スクロールをオフにする
          momentumRatio: .8, // 数字が大きいほど惰性スクロールの距離が伸びる（freeMode: trueとfreeModeMomentum:trueが前提）
          modeMomentumVelocityRatio: .2, // 数字が大きいほど惰性スクロールのスピードが速くなる（freeMode: trueとfreeModeMomentum:trueが前提）
          sticky: false,  // true:スナップを有効にする
        },
        */

        loop: true, // ループ
        preventClicks: true, // true: スワイプ中の不要なクリックを無効化
        preventClicksPropagation: true, // true: スワイプ中の不要なクリックイベントを無効化

        // ナビゲーション
        navigation: {
          nextEl: '.swiper-button-next', // 「次へ」ボタン要素のクラス
          prevEl: '.swiper-button-prev', // 「前へ」ボタン要素のクラス
        },

        // ページネーション
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        /*
        scrollbar: {
          el: '.swiper-scrollbar', // スクロールバー要素のクラス
          draggable: true,
        },
        */

      };
    } else {
      // 1枚以下の場合
      opt = {
        loop: false,      // ループ解除
        autoplay: false,  // オートプレイ解除
      };
      document.querySelector('.swiper-ui').style.display = 'none'; // UIを削除
    }

    const swiperClub = new Swiper('.swiper', opt);  // eslint-disable-line @typescript-eslint/no-unused-vars
  }
}
